import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { WidgetLayoutComponent } from '../widget-layout/widget-layout.component';
import { NotificationBannerComponent } from '../notification-banner/notification-banner.component';
import { UserService } from '@/app/services/user.service';
import { UserViewModel } from '@/app/models/user.model';
import { DisplayLocalePipe } from "../../pipes/display-locale.pipe";
import { toSignal } from '@angular/core/rxjs-interop';
import { HeaderMostVisitedComponent } from './components/header-most-visited/header-most-visited.component';
import { TranslateModule } from '@ngx-translate/core';
import { HomeService } from '@/app/services/home.service';


@Component({
	selector: 'dr-flex-home-ui-home',
	templateUrl: './home.component.html',
	standalone: true,
	imports: [WidgetLayoutComponent, NotificationBannerComponent, DisplayLocalePipe, HeaderMostVisitedComponent, TranslateModule],
	styleUrls: ['./home.component.scss'],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomeComponent {
	private readonly userService = inject(UserService);
	private readonly homeService = inject(HomeService);
	readonly userSignal = toSignal<UserViewModel | null>(this.userService.getUserFirstName(), { initialValue: null });
	readonly hasCOMSignal = toSignal(this.homeService.getHasCOM(), { initialValue: false });
}
